export default "__VITE_PUBLIC_ASSET__bcae08ea__"